import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnablePasswordPut extends RunnableOperation {
  operationId: string

  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
    this.operationId = userOpSpec.operationId || ''
    this.userOpSpec = userOpSpec
  }

  async init(context: OperationContext): Promise<boolean> {
    // Implementa la logica di inizializzazione qui
    return true
  }

  async defineRequest(context: OperationContext): Promise<void> {
    if (this.aborted) {
      throw new Error('Operation aborted')
    }

    context.declareRequestSpec = {
      operationType: 'password.put',
      pathName: this.userOpSpec.to,
      encriptionIV: this.userOpSpec.iv,
      encriptionDEK: this.userOpSpec.enc_dek,
      contentMD5: this.userOpSpec.md5,
      contentLength: this.userOpSpec.encrypted_content?.length || 0,
      content: {
        info: this.userOpSpec.info,
        encrypted_content: this.userOpSpec.encrypted_content,
      },
    }
  }

  async execute(context: OperationContext): Promise<void> {
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    // Implementa la logica di esecuzione qui
  }

  async requestCompleted(context: OperationContext): Promise<boolean> {
    // Implementa la logica post-richiesta qui
    return true
  }

  abort(): void {
    this.aborted = true
  }
}
